import { getDefaultStore, useAtomValue, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const fcmToken = atomWithStorage<string | undefined>(
  'fcm:token',
  undefined,
  undefined,
  {
    getOnInit: true,
  },
);

export const getFcmTokenSync = () => {
  const store = getDefaultStore();
  return store.get(fcmToken);
};

export const useSetFcmToken = () => {
  return useSetAtom(fcmToken);
};

export const useGetFcmToken = () => {
  return useAtomValue(fcmToken);
};
